import { render } from "./Claim_3_approvedBillList.vue?vue&type=template&id=7c354eac&scoped=true&ts=true"
import script from "./Claim_3_approvedBillList.vue?vue&type=script&lang=ts"
export * from "./Claim_3_approvedBillList.vue?vue&type=script&lang=ts"

import "./Claim_3_approvedBillList.vue?vue&type=style&index=0&id=7c354eac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c354eac"]])

export default __exports__